<!-- The subscription packages (shared component) -->
<card-account-packages></card-account-packages>
